const CURRENCY_FORMAT: Record<
  string,
  { locale: string; fractionDigits: number }
> = {
  USD: { locale: "en-US", fractionDigits: 2 },
  MXN: { locale: "es-MX", fractionDigits: 2 },
  COP: { locale: "es-CO", fractionDigits: 0 },
  PEN: { locale: "es-PE", fractionDigits: 2 },
  CLP: { locale: "es-CL", fractionDigits: 0 },
  ARS: { locale: "es-AR", fractionDigits: 2 },
};

const fallbackFormat = (currency: string) =>
  currency === "USD"
    ? { locale: "en-US", fractionDigits: 2 }
    : { locale: "es-CO", fractionDigits: 0 };

export const formatPriceAmount = (currency: string, price: number) => {
  const { locale, fractionDigits } =
    CURRENCY_FORMAT[currency] ?? fallbackFormat(currency);
  return new Intl.NumberFormat(locale, {
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  }).format(price);
};

export const formatPrice = (currency: string, price: number) =>
  `${currency} $${formatPriceAmount(currency, price)}`;
